import { AxiosResponse } from 'axios'

const resource = http => ({
  getAll(productCategory: string) {
    return http({
      method: 'get',
      url: `/tags?productCategory=${productCategory}`
    })
  }
})

export interface TagsHttpModel {
  getAll: (productCategory: string) => Promise<AxiosResponse>
}

export default resource
